import { render, staticRenderFns } from "./quota.vue?vue&type=template&id=70fff4b0"
import script from "./quota.vue?vue&type=script&lang=js"
export * from "./quota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports